/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:9a654ecd-be32-4e2f-8a98-f65f0e560da2",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_GEilkxFPf",
    "aws_user_pools_web_client_id": "65r12m844q7mvog7mjvpj5u777",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "requests6b75835a6b6b43ceae12efe85948b077231844-requests",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
